import Upsertable from '@/models/Upsertable'
import { useAgriOrderStore } from '@/stores/agriOrderStore'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

// How connect's SBG UG back office splits orders (Partners::SbgUg::AgriOrdersController#index)
export const SBG_OPEN_STATUSES = ['open', 'placed', 'paid']
export const SBG_CLOSED_STATUSES = ['closed', 'confirmed', 'delivered']

export default class AgriOrder extends Upsertable {
  static isSbgOpen(order) {
    return SBG_OPEN_STATUSES.includes(order.status)
  }

  static isSbgClosed(order) {
    return SBG_CLOSED_STATUSES.includes(order.status)
  }

  // The server saves an order sent with no farmer, so an order placed before the form required one leaves the
  // phone. The agent who placed it is the one who knows its farmer, and chooses it with the order page's EDIT.
  static hasNoFarmer(order) {
    return !order.deliver_to_uuid
  }

  // Whether the order page offers EDIT and CANCEL ORDER
  static isSbgEditable(order) {
    return order.status == 'open' && !order.batched_at
  }

  static store() {
    return useAgriOrderStore()
  }

  store() {
    return AgriOrder.store()
  }

  static find(uuid) {
    const store = AgriOrder.store();
    return store.collection.find(item => item.uuid === uuid);
  }

  static confirmDelivery(uuid) {
    return AgriOrder.store().confirmDelivery(uuid)
  }

  static cancelOrder(uuid) {
    return AgriOrder.store().cancelOrder(uuid)
  }
  
  calcTotal() {
    if (this.agri_order_products) {
      let total = 0
      this.agri_order_products.forEach(function (agriOrderProduct) {
        total += agriOrderProduct.price * agriOrderProduct.quantity
      })
      return total
    } else {
      return 0
    }
  }
}

useModelName(AgriOrder, "AgriOrder")
ModelRegistry.register(AgriOrder, "AgriOrder")